import React, { useEffect, useState } from "react";
import Styles from "./Heading.module.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as LineIcon } from "../../../assets/images/line.svg";
import { ReactComponent as Sort } from "../../../assets/images/sort.svg";
import FilterModal from "../FilterModal/FilterModal";

const AvailableHeader = ({
  onSortChange,
  currentSort,
  onApplyFilters,
  appliedFilters,
  filteredCount,
}) => {
  const [settlementType, setSettlementType] = useState("all");
  const [bankingFactor, setBankingFactor] = useState("all");
  const [filterOpen, setFilterOpen] = useState(false);

  const bankingState = useSelector((state) => state.bankingSlice);
  const matchmakingData = bankingState.matchmakingData;
  const mixedMatches = [...(matchmakingData?.matches || [])];
  const availableListingCount =
    filteredCount !== undefined ? filteredCount : mixedMatches.length;

  // Utility function to count applied filters
  const getActiveFilterCount = () => {
    if (!appliedFilters) return 0;

    let count = 0;

    // Check quantity range (if different from default [0, 10000])
    if (
      appliedFilters.quantityRange &&
      (appliedFilters.quantityRange[0] !== 0 ||
        appliedFilters.quantityRange[1] !== 10000)
    ) {
      count++;
    }

    // Check settlement rate range (if different from default [-9, 9])
    if (
      appliedFilters.settlementRateRange &&
      (appliedFilters.settlementRateRange[0] !== -9 ||
        appliedFilters.settlementRateRange[1] !== 9)
    ) {
      count++;
    }

    // Check banking factor range (if different from default [100, 200])
    if (
      appliedFilters.bankingFactorRange &&
      (appliedFilters.bankingFactorRange[0] !== 100 ||
        appliedFilters.bankingFactorRange[1] !== 200)
    ) {
      count++;
    }

    // Check credit rating
    if (
      appliedFilters.selectedCreditRating &&
      appliedFilters.selectedCreditRating !== ""
    ) {
      count++;
    }

    // Check injection modals (if any have values)
    if (appliedFilters.injectionModals) {
      const hasInjectionFilters = appliedFilters.injectionModals.some((modal) =>
        modal.some(
          (item) =>
            item.startTime ||
            item.endTime ||
            item.startDate ||
            item.endDate ||
            item.quantity ||
            item.rtcChecked,
        ),
      );
      if (hasInjectionFilters) count++;
    }

    // Check drawal modals (if any have values)
    if (appliedFilters.drawalModals) {
      const hasDrawalFilters = appliedFilters.drawalModals.some((modal) =>
        modal.some(
          (item) =>
            item.startTime ||
            item.endTime ||
            item.startDate ||
            item.endDate ||
            item.quantity ||
            item.rtcChecked,
        ),
      );
      if (hasDrawalFilters) count++;
    }

    return count;
  };

  const activeFilterCount = getActiveFilterCount();

  const handleSortClick = () => {
    onSortChange(currentSort === "asc" ? "desc" : "asc");
  };

  return (
    <>
      {filterOpen && (
        <FilterModal
          open={filterOpen}
          handleClose={() => setFilterOpen(false)}
          onApplyFilters={onApplyFilters}
          currentFilters={appliedFilters}
        />
      )}
      <div className={`display_flex_row ${Styles.selfHeaderContainer}`}>
        <div
          className={`display_flex_row_center ${Styles.selfHeaderLeft} ${Styles.availableHeader}`}
        >
          <span>Available Matches: </span>
          <span>{availableListingCount}</span>
        </div>
        <div
          className={` display_flex_row_center ${Styles.availableListingSortFilter}`}
        >
          <div className={Styles.sortHead}>Sort:</div>
          <div className={Styles.sortButton} onClick={handleSortClick}>
            Expiry Date {currentSort === "asc" && "↑"}
            {currentSort === "desc" && "↓"}
            {currentSort === null && (
              <Sort
                style={{
                  width: "25px",
                  height: "15px",
                  verticalAlign: "middle",
                }}
              />
            )}
          </div>{" "}
          <span style={{ color: "var(--primary-color-text)" }}>
            <LineIcon />
          </span>
          <div
            className={`display_flex_row_center ${Styles.filterButton} ${
              activeFilterCount > 0 ? Styles.filterButton : ""
            }`}
            onClick={() => setFilterOpen(true)}
          >
            <span>Filter</span>
            <ExpandMoreIcon style={{ fontSize: "16px" }} />
            {activeFilterCount > 0 && (
              <span className={Styles.filterCount}>{activeFilterCount}</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AvailableHeader;
